import { observable, action, runInAction, decorate, reaction } from 'mobx';
import agent from '../api/agent';
import { toast } from 'react-toastify';
import { RootStore } from './RootStore';
import {
    IRequestReviewDocumentAnswer,
    RequestReviewDocumentAnswerFormValues
} from "../models/RequestReviewDocumentAnswer";
import { DocumentQuestions, IRequestReviewDocument } from '../models/RequestReviewDocument';

export default class RequestReviewDocumentAnswerStore {
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
        this.rootStore = rootStore
        reaction(
            () => this.predicate.keys(),
            () => {
                this.reviewDocumentAnswerPages = 0;
                this.RequestReviewDocumentAnswerRegistry.clear();
            }
        )
    }

    RequestReviewDocumentAnswerRegistry = new Map();
    RequestReviewDocumentAnswer: IRequestReviewDocumentAnswer | null = null;
    loadingInitialReviewDocumentAnswers = false;
    QuestionNotComplete = false;
    submitting = false;
    target = "";
    requestReviewDocumentAnswerCount = 0;
    reviewDocumentAnswerPages = 0;
    predicate = new Map();

    handleSubmit = async (values: any) => {
        this.submitting = true
        this.QuestionNotComplete = false
        const fields = [] = values.target.children;
        try {
            for (const a of fields) {
                if (a.firstChild.id != "") {
                    const isDropdown = a.firstChild.lastElementChild.firstChild?.firstChild.type != "text";
                    const isTextResponse = a.firstChild.lastElementChild.firstChild?.firstChild.type == "text";
                    if (isDropdown && a.firstChild.lastElementChild.firstChild?.firstChild.innerText == ""){
                        this.QuestionNotComplete = true;
                    }
                    // if (isTextResponse && a.firstChild.lastElementChild.firstChild?.firstChild.value == "") {
                    //     this.QuestionNotComplete = true;
                    // }
                    if (!isDropdown && !isTextResponse){
                        this.QuestionNotComplete = true;
                    }
                }
            }

            if (!this.QuestionNotComplete) {
                let answersForm: RequestReviewDocumentAnswerFormValues[] = [];
                for (const a of fields) {
                    if (a.firstChild.id != "") {

                        const isDropdown = a.firstChild.lastElementChild.firstChild?.firstChild.type != "text";
                        const isTextResponse = a.firstChild.lastElementChild.firstChild?.firstChild.type == "text";

                        let newAnswer = {} as RequestReviewDocumentAnswerFormValues;
                        newAnswer.requestReviewDocumentId = a.parentElement.id;
                        newAnswer.documentQuestionId = a.firstChild.id;
                        newAnswer.documentTypeId = isTextResponse?a.firstChild.lastElementChild.firstChild.firstChild.id:a.firstChild.lastElementChild.firstChild.id;
                        newAnswer.answer =isDropdown? (a.firstChild.lastElementChild.firstChild?.firstChild.innerText == 'Yes' ? true : false):false;
                        newAnswer.answerText =isTextResponse? a.firstChild.lastElementChild.firstChild?.firstChild.value:"";
                        newAnswer.documentQuestion = a.firstChild.innerText.substring(0, a.firstChild.innerText.indexOf('?') + 1);

                        answersForm.push(newAnswer);
                    }
                }
                if (answersForm.length != 0) {
                    await this.editRequestReviewDocumentAnswers(answersForm);

                    let requestReviewDoc: IRequestReviewDocument = this.rootStore.requestReviewDocumentStore.RequestReviewDocumentRegistry.get(answersForm[0].requestReviewDocumentId)

                    let documentQuestions: DocumentQuestions[] = [];
                    answersForm.forEach(element => {
                        let documentQuestion: DocumentQuestions = {} as DocumentQuestions;
                        documentQuestion.answer = element.answer;
                        documentQuestion.answerText = element.answerText;
                        documentQuestion.id = element.documentQuestionId;
                        documentQuestion.question = element.documentQuestion;
                        documentQuestion.responseType = requestReviewDoc.questions.filter((question) => question.id == element.documentQuestionId)[0].responseType;

                        documentQuestions.push(documentQuestion);
                    });
                    requestReviewDoc.questions = documentQuestions;
                    this.rootStore.requestReviewDocumentStore.RequestReviewDocumentRegistry.set(answersForm[0].requestReviewDocumentId, requestReviewDoc)

                    this.rootStore.requestReviewDocumentStore.CheckForUnAnsweredQuestions();
                    toast.success("Questions updated")
                }
                else {
                    toast.success("No questions to update")
                }

            } else {
                toast.info("All questions must be answered before submission.")
            }

        } catch (error) {
            console.log(error)
            toast.error("Error updating answers")
        }
        runInAction('editRequestAnswer', () => {
            this.submitting = false;
        });
    }

    editRequestReviewDocumentAnswers = async (RequestReviewDocumentAnswerFormValues: RequestReviewDocumentAnswerFormValues[]) => {
        try {
            await agent.RequestReviewDocumentAnswer.Answers(RequestReviewDocumentAnswerFormValues);
        } catch (error) {
            toast.error('problem submitting data');
            throw error;
        }
    };

    editRequestReviewDocumentAnswer = async (RequestReviewDocumentAnswerFormValues: RequestReviewDocumentAnswerFormValues) => {
        try {
            await agent.RequestReviewDocumentAnswer.Answer(RequestReviewDocumentAnswerFormValues.requestReviewDocumentId, RequestReviewDocumentAnswerFormValues);
        } catch (error) {
            toast.error('problem submitting data');
            throw error;
        }
    };


}

decorate(RequestReviewDocumentAnswerStore, {
    RequestReviewDocumentAnswerRegistry: observable,
    RequestReviewDocumentAnswer: observable,
    loadingInitialReviewDocumentAnswers: observable,
    submitting: observable,
    target: observable,
    requestReviewDocumentAnswerCount: observable,
    reviewDocumentAnswerPages: observable,
    predicate: observable,

    handleSubmit: action,
    editRequestReviewDocumentAnswer: action,
});